import { createStore } from 'vuex'

export default createStore({
  state: {
    token: localStorage.getItem('web_token') || '',
    user: null // { _id, phone, name }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userInfo: state => state.user
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('web_token', token)
    },
    setUser(state, user) {
      state.user = user
    },
    clearAuth(state) {
      state.token = ''
      state.user = null
      localStorage.removeItem('web_token')
    }
  },
  actions: {
    async fetchUser({ commit, state }) {
      if (!state.token) return
      try {
        const res = await fetch('/webapi/dent/customer/me', {
          headers: { 'Authorization': `Bearer ${state.token}` }
        })
        const data = await res.json()
        if (data.ActionType === 'OK' && data.data) {
          commit('setUser', data.data)
        } else {
          commit('clearAuth')
        }
      } catch {
        commit('clearAuth')
      }
    },
    async login({ commit }, { phone, password }) {
      const res = await fetch('/webapi/dent/customer/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone, password })
      })
      const data = await res.json()
      const token = res.headers.get('authorization') || data.data?.token || ''
      if (data.ActionType === 'OK' && token) {
        commit('setToken', token)
        commit('setUser', { phone, name: data.data.name || phone })
      }
      return data
    },
    logout({ commit }) {
      commit('clearAuth')
    }
  }
})
